if (!window.loadHubSpotForms) {
  const hubSpotFormsUrl = 'https://js.hsforms.net/forms/embed/developer/6272882.js';
  let hubSpotRequested = false;

  window.loadHubSpotForms = () => {
    if (hubSpotRequested || document.querySelector(`script[src="${hubSpotFormsUrl}"]`)) return;

    hubSpotRequested = true;
    const script = document.createElement('script');
    script.src = hubSpotFormsUrl;
    script.async = true;
    document.head.appendChild(script);
  };

  const observeEmbeds = () => {
    const embeds = document.querySelectorAll('.hs-form-html');
    if (!embeds.length) return;

    if (!('IntersectionObserver' in window)) {
      if (document.readyState === 'complete') window.loadHubSpotForms();
      else window.addEventListener('load', window.loadHubSpotForms, { once: true });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        observer.disconnect();
        window.loadHubSpotForms();
      },
      { rootMargin: '400px 0px' }
    );

    embeds.forEach((embed) => observer.observe(embed));
  };

  const loadOnQuoteIntent = (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('[data-hubspot-form-trigger]')) return;

    window.loadHubSpotForms();
  };

  const loadOnHubSpotDialogOpen = (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.querySelector('.hs-form-html')) return;

    window.loadHubSpotForms();
  };

  document.addEventListener('pointerover', loadOnQuoteIntent, { passive: true });
  document.addEventListener('focusin', loadOnQuoteIntent);
  document.addEventListener('touchstart', loadOnQuoteIntent, { passive: true });
  document.addEventListener('click', loadOnQuoteIntent);
  document.addEventListener('dialog:open', loadOnHubSpotDialogOpen, { capture: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeEmbeds, { once: true });
  } else {
    observeEmbeds();
  }
}
